import { action } from 'satcheljs/lib/legacy';
import { default as getNotesSDK } from '../utils/getNotesSDK';
export default action('enableNotesDarkMode')(function enableNotesDarkMode(enable: boolean) {
    getNotesSDK().enableDarkMode(enable);
});
